
//For any modification refer to Warden ID on products table to add to any array of compatible products

export const usProducts = {
  chlorinePool: {
    sanitizers: [87, 88, 96, 26, 85, 84, 93], // Default 93 -- smart silkguard sticks
    maintOxidizers: [51, 29, 17, 27], // Default 27 -- smart shock
    prevAlgicides: [40, 33, 28, 39], // Default 39 -- back up 2
    maintClarifiers: [31],
  },
  saltWaterPool: {
    sanitizers: [82], //Saltwater Sanitizer
    maintOxidizers: [51, 29, 17, 27], // Default 27 -- smart shock
    prevAlgicides: [39, 40, 33, 78, 28], // Default 39 -- back up 2
    maintClarifiers: [31],
  },
  mineralSpringsPool: {
    sanitizers: [55], //Mineral Springs Sanitizer
    maintOxidizers: [51, 29, 17, 59, 27], // Default 27 -- smart shock
    prevAlgicides: [40, 33, 78, 58, 28, 39], // Default 39 -- back up 2
    maintClarifiers: [31],
  },
};


export const caProducts = {
  chlorinePool: {
    sanitizers: [86, 182, 93],
    maintOxidizers: [168, 164, 29, 27],
    prevAlgicides: [38, 40, 52],
    maintClarifiers: [31],
  },
  saltWaterPool: {
    sanitizers: [82],
    maintOxidizers: [168, 164, 29, 27],
    prevAlgicides: [38, 40, 52],
    maintClarifiers: [31],
  },
  mineralSpringsPool: {
    sanitizers: [55],
    maintOxidizers: [168, 164, 29, 27, 0],
    prevAlgicides: [38, 40, 52, 0],
    maintClarifiers: [31],
  },
};
